/* Space Explorer teaser (snippets/ap-space-teaser.liquid).
   A live mini floor plan: tap rooms to tick them and the CTA deep-links into the finder with those
   rooms. Every room starts unselected (owner 2026-10-05); until someone touches it, a soft glow
   travels from room to room as a cue (nothing is ticked or dimmed). Picked rooms stay lit,
   the rest of the plan dims (same effect as the finder). Pin points match the finder's house plan. */
(function () {
  // Same plans, pins and room ids as the finder (assets/ap-space-explorer.js PLANS).
  var PLANS = {
    house: { alt: 'A two-story home in warm daylight with every room visible', pins: [
      ['bedroom', 'Bedroom', 'Bedroom', 28.6, 41], ['bathroom', 'Bathroom', 'Bath', 50.4, 27.5], ['office', 'Home office', 'Office', 65.4, 34],
      ['kitchen', 'Kitchen', 'Kitchen', 24.6, 60.2], ['living', 'Living room', 'Living', 49.3, 76.8], ['entry', 'Entry', 'Entry', 63.2, 59, 'l'], ['car', 'Car', 'Car', 75.7, 58.3]] },
    apartment: { alt: 'A city apartment in warm daylight with every room visible', pins: [
      ['living', 'Living room', 'Living', 40, 56.3], ['kitchen', 'Kitchen', 'Kitchen', 55, 32], ['bedroom', 'Bedroom', 'Bedroom', 70, 57.6],
      ['bathroom', 'Bathroom', 'Bath', 59.3, 65.3], ['office', 'Home office', 'Office', 51.4, 79], ['entry', 'Entry', 'Entry', 42.9, 75.5, 'l']] },
    business: { alt: 'A boutique business space in warm daylight with every area visible', pins: [
      ['lobby', 'Reception lobby', 'Lobby', 24.3, 55], ['retail', 'Retail floor', 'Retail', 37.9, 42.3], ['meeting', 'Meeting room', 'Meeting', 52.9, 34.6, 'l'],
      ['workspace', 'Open office', 'Office', 52.9, 71.7], ['restroom', 'Restroom', 'Restroom', 66.4, 38.4], ['treatment', 'Treatment room', 'Spa room', 75, 53.8, 'l']] }
  };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var check = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';

  function init(root) {
    if (root.dataset.apstBound) return;
    root.dataset.apstBound = '1';
    var plan = root.querySelector('.apst__plan'), lit = root.querySelector('.apst__lit'), host = root.querySelector('[data-apst-pins]');
    var demoOnly = root.hasAttribute('data-apst-demo-only');
    var imgsEl = root.querySelector('[data-apst-imgs]'), IMGS = imgsEl ? JSON.parse(imgsEl.textContent) : null;
    var planKey = 'house', PINS = PLANS.house.pins;
    function pinsHtml() { return PINS.map(function (p, i) {
      var tag = demoOnly ? 'span' : 'button type="button"';
      return '<' + tag + ' class="apst__pin' + (p[5] === 'l' ? ' apst__pin--l' : '') + '" style="--x:' + p[3] + ';--y:' + p[4] + ';--d:' + i + '" data-room="' + p[0] + '"' +
        (demoOnly ? '' : ' aria-pressed="false" aria-label="' + p[1] + '"') + '><b>' + check + (demoOnly ? '' : '<i class="apst__wisp"></i><i class="apst__wisp"></i><i class="apst__wisp"></i>') + '</b>' +
        (demoOnly ? '' : '<span><i class="apst__full">' + p[1] + '</i><i class="apst__short">' + p[2] + '</i></span>') + '</' + (demoOnly ? 'span' : 'button') + '>';
    }).join(''); }
    host.innerHTML = pinsHtml();
    var picked = [], touched = false, scale = {}, raf = 0, timer = 0;

    function draw() {
      var box = plan.getBoundingClientRect(); if (!box.width) return;
      var w = box.width, small = w < 420;
      var holes = Object.keys(scale).map(function (id) {
        var b = host.querySelector('[data-room="' + id + '"] b'); if (!b) return '';
        var r = b.getBoundingClientRect(), x = r.left + r.width / 2 - box.left, y = r.top + r.height / 2 - box.top, k = scale[id];
        var inner = Math.round(w * (small ? 0.08 : 0.06) * k), outer = Math.max(inner + 1, Math.round(w * (small ? 0.18 : 0.14) * k));
        return 'radial-gradient(circle at ' + Math.round(x) + 'px ' + Math.round(y) + 'px, transparent 0 ' + inner + 'px, #000 ' + outer + 'px)';
      }).filter(Boolean);
      plan.classList.toggle('is-lit', holes.length > 0);
      if (holes.length) lit.style.webkitMaskImage = lit.style.maskImage = holes.join(', ');
    }
    function light() {
      var ids = picked;
      host.querySelectorAll('[data-room]').forEach(function (el) {
        var on = ids.indexOf(el.dataset.room) > -1;
        el.classList.toggle('is-on', on);
        if (!demoOnly) el.setAttribute('aria-pressed', String(on));
      });
      // Nothing picked: fade the dim layer straight out so the whole plan is lit again (no dark flash).
      if (!ids.length) { cancelAnimationFrame(raf); scale = {}; plan.classList.remove('is-lit'); return; }
      ids.forEach(function (id) { if (!(id in scale)) scale[id] = reduced ? 1 : 0; });
      var from = {}, start = performance.now();
      Object.keys(scale).forEach(function (id) { from[id] = scale[id]; });
      cancelAnimationFrame(raf);
      (function frame(now) {
        var t = reduced ? 1 : Math.min(1, (now - start) / 360), e = 1 - Math.pow(1 - t, 3);
        Object.keys(from).forEach(function (id) {
          var to = ids.indexOf(id) > -1 ? 1 : 0;
          scale[id] = from[id] + (to - from[id]) * e;
          if (t === 1 && to === 0) delete scale[id];
        });
        draw();
        if (t < 1) raf = requestAnimationFrame(frame);
      })(start);
      host.querySelectorAll('[data-room]').forEach(function (el) {
        var on = ids.indexOf(el.dataset.room) > -1;
        el.classList.toggle('is-on', on);
        if (!demoOnly) el.setAttribute('aria-pressed', String(on));
      });
    }
    function sync() {
      var cta = root.querySelector('[data-apst-cta]'); if (!cta) return;
      var url = root.dataset.apstUrl, src = root.dataset.apstSrc, n = picked.length;
      var names = picked.map(function (id) { return PINS.filter(function (p) { return p[0] === id; })[0][2]; });
      cta.href = url + '?' + (planKey !== 'house' ? 'plan=' + planKey + '&' : '') + (n > 1 ? 'rooms=' + picked.join(',') + '&' : n ? 'room=' + picked[0] + '&' : '') + 'src=' + encodeURIComponent(src);
      var noun = planKey === 'business' ? 'space' : 'room';
      root.querySelector('[data-apst-label]').textContent = n ? 'Continue with ' + n + ' ' + noun + (n > 1 ? 's' : '') : 'Start with your ' + noun + 's';
      root.querySelector('[data-apst-names]').textContent = n === 1 ? names[0] + ' · tap more to add them' : n ? names.join(' · ') : 'Takes under a minute';
      cta.classList.toggle('is-ready', n > 0);
      if (n && !reduced) { cta.classList.remove('is-bump'); void cta.offsetWidth; cta.classList.add('is-bump'); }
    }
    // Cue: a soft glow travels from room to room until someone taps. Nothing is selected by it.
    var step = 0;
    function tick() {
      if (touched) return;
      host.querySelectorAll('.is-cue').forEach(function (el) { el.classList.remove('is-cue'); });
      var el = host.querySelector('[data-room="' + PINS[step % PINS.length][0] + '"]');
      if (el) el.classList.add('is-cue');
      step++; timer = setTimeout(tick, 1300);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !touched) { if (!timer) timer = setTimeout(tick, 700); }
          else { clearTimeout(timer); timer = 0; }
        });
      }, { threshold: 0.35 });
      io.observe(plan);
    }
    if (!demoOnly) {
      host.addEventListener('click', function (e) {
        var b = e.target.closest('[data-room]'); if (!b) return;
        if (!touched) { touched = true; clearTimeout(timer); root.classList.add('is-touched'); host.querySelectorAll('.is-cue').forEach(function (el) { el.classList.remove('is-cue'); }); }
        var id = b.dataset.room, i = picked.indexOf(id);
        if (i > -1) picked.splice(i, 1); else picked.push(id);
        light(); sync();
      });
    }
    // House / Apartment / Business: swap the plan (soft cross-fade), reset picks, keep the cue going.
    root.querySelectorAll('[data-apst-plan]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var k = tab.dataset.apstPlan; if (k === planKey || !PLANS[k] || !IMGS) return;
        planKey = k; PINS = PLANS[k].pins; picked = []; step = 0;
        root.querySelectorAll('[data-apst-plan]').forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
        var img = plan.querySelector('.apst__img');
        plan.classList.add('is-swapping');
        setTimeout(function () {
          img.srcset = IMGS[k][0] + ' 1100w, ' + IMGS[k][1] + ' 1920w'; img.src = IMGS[k][1]; img.alt = PLANS[k].alt;
          host.innerHTML = pinsHtml(); scale = {}; draw(); light(); sync();
          var done = function () { plan.classList.remove('is-swapping'); };
          if (img.complete) requestAnimationFrame(done); else { img.onload = done; setTimeout(done, 900); }
        }, reduced ? 0 : 220);
      });
    });
    window.addEventListener('resize', draw);
  }
  function boot() { document.querySelectorAll('[data-apst]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
